<div>
    <ol>
        <li ng-repeat="item in items" ng-click="onSelect(item)">
            <div list-item ng-class="{'selected': item == selectedItem}">
                <div c-scroll-overflow>
                    <h3>
                        <a ng-if="item.callback" ng-click="onClick(item, $event)">{{localize(item.Name)}}</a>
                        <span ng-if="!item.callback">{{localize(item.Name)}}</span>
                    </h3>
                    <div ng-if="toggle">
                        <div list-item-description c-toggle="item == selectedItem" ng-class="{'selected': item == selectedItem}" ng-show="item.Description">
                            {{localize(item.Description)}}
                        </div>
                    </div>
                    <div ng-if="!toggle">
                        <div list-item-description ng-class="{'selected': item == selectedItem}" ng-show="item.Description">
                            {{localize(item.Description)}}
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ol>
</div>

